import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { contactoUpdateSuccessAlert } from "../constants"

const useContactoDetails = ({
  id,
  fetch,
  update,
  post,
  onUpdateSuccess,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const [data, setData] = useState([])

  const handleSuccess = (
    // @ts-expect-error TS(6133): 'response' is declared but its value is never read...
    response: $TSMigrationFixMe,
    showSuccess: $TSMigrationFixMe
  ) => {
    if (showSuccess) {
      contactoUpdateSuccessAlert(t)
      onUpdateSuccess?.(id)
    }
  }

  const fetchData = () => {
    if (id)
      fetch?.(id)?.then((response: $TSMigrationFixMe) =>
        setData(response?.data ?? response)
      )
  }

  const updateData = (payload: $TSMigrationFixMe) => {
    update?.(id, payload)?.then((response: $TSMigrationFixMe) => {
      handleSuccess(response, true)
    })
  }

  const postData = (payload: $TSMigrationFixMe) => {
    post?.({ id, requestBody: payload })?.then(
      (response: $TSMigrationFixMe) => {
        handleSuccess(response, true)
      }
    )
  }

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  return {
    data,
    setData,
    fetchData,
    updateData,
    postData,
  }
}

export default useContactoDetails
